import SocialPartnerCard from "./SocialPartnerCard";

export default SocialPartnerCard;
